$shm_hitalama_map_widget_float_settings_customdom $shm_hitalama_map_widget_float_settings
	controlled_settings_content /
		<= Code
